import { FileDownload } from "@mui/icons-material";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import moment from "moment";

export const fertilizerInput = (data, fuel, parcel) => {
  if (data.records.length === 0) return ' - ';
  let fuelInfo = '';
  if (!fuel.isDirect) {
    let fuelTotal = 0;

    let filtered = fuel.estimated.filter(item => {
      return item.operation.toLowerCase().indexOf('fertilizer') > -1 || item.operationCategory.toLowerCase().indexOf('fertilizer') > -1
    });

    if (filtered.length > 0) {
      filtered.map(obj => {
        fuelTotal += parseFloat(estimatedConsumption(parcel.area, obj));
      })

      fuelInfo = ` | Fuel Consumption: ${fuelTotal} L`;

    }

  }

  return (
    <>
      <List dense>
        {data.records.map((record, index) => (
          <ListItem className="co-background" key={index} secondaryAction={record.date || ' - '}>
            <ListItemText primary={record.product} secondary={'Amount: ' + record.amount + ' kg' + fuelInfo}></ListItemText>
          </ListItem>
        ))}
      </List>
    </>
  )
}

export const pesticidesInput = (data, fuel, parcel) => {
  if (!Boolean(data.totalEmission)) return ' - ';
  let fuelInfo = '';
  let filtered = fuel.estimated.filter(item => {
    return item.operation.toLowerCase().indexOf('plant protection') > -1 || item.operationCategory.toLowerCase().indexOf('plant protection') > -1
  });

  if(filtered.length > 0) {

    let fuelTotal = 0;

    filtered.map(obj => {
      fuelTotal += parseFloat(estimatedConsumption(parcel.area, obj));
    })
    fuelInfo = ` | Fuel Consumption: ${fuelTotal} L`;
    console.log(filtered)
    }

  return (
    <List dense>
      <ListItem className="co-background" secondaryAction={data.date || ' - '}>
        <ListItemText primary={data.type} secondary={'Amount: ' + data.amountP + ' kg' + fuelInfo}></ListItemText>
      </ListItem>
    </List>
  )
}

export const residuesInput = (data) => {
  if (!Boolean(data.totalEmission)) return ' - ';
  return (
    <List dense>

      <ListItem className="co-background" secondaryAction={data.date || ' - '}>
        <ListItemText primary={`Management: ${data.management.toUpperCase()}`} secondary={`Amount ${data.management}: ${data.management === 'burned' ? data.amountBurned : data.amountLeft} kg`}></ListItemText>
      </ListItem>
    </List>
  )
}

export const irrigationInput = (data, parcel) => {
  if (data.records.length === 0) return ' - ';
  return (
    <List dense>
      {data.records.map((record, index) => (
        <ListItem className="co-background" key={index}>
          <ListItemText primary={record.method + ' - ' + record.fuel} secondary={'Irrigation depth:' + record.depth + ' mm' + ` | Irrigated area: ${Math.round(parcel.area * record.percentage / 100)} ha`}></ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

export const animalsInput = (data, parcel) => {
  if (data.records.length === 0) return ' - ';
  return (
    <List dense>
      {data.records.map((record, index) => (
        <ListItem className="co-background" key={index} secondaryAction={`Number of animals: ${record.numberOfAnimals}`}>
          <ListItemText primary={record.category.name} secondary={`Days on the field: ${(record.hours / 24).toFixed(1)}`}></ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

const transportConsumption = (record) => {

  if (record.transportLength && record.transportMass) {
    return parseFloat(record.transportLength) * (parseFloat(record.transportMass) / 1000) * 0.09; // Example calculation, adjust as needed
  }

  return 0;
}

const estimatedConsumption = (area, record) => {
  if (record.operationCategory === 'Root crop harvesting') {
    return `${(record.consumption * record.numberOfBales + transportConsumption(record)).toFixed(0)} [L]`
  }
  return `${(record.consumption * area + transportConsumption(record)).toFixed(0)} [L]`
}


export const soilManagement = (data, parcel) => {
  let filtered = data.estimated.filter(item => {
    return item.operationCategory.indexOf("Soil cultivation") > -1 ||
      item.operation.toLowerCase().indexOf('mulching') > -1
  });

  if (filtered.length === 0) return ' - ';

  return (
    <List dense>
      {filtered.map((record, index) => (
        <ListItem className="co-background" key={index} secondaryAction={`Power Source: ${record.source}`}>
          <ListItemText primary={record.operationCategory} secondary={`${record.operation} | Consumption: ${estimatedConsumption(parcel.area, record)}`}></ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

export const pruning = (data, parcel) => {
  let filtered = data.estimated.filter(item => {
    return item.operation.toLowerCase().indexOf('pruning') > -1
  });

  if (filtered.length === 0) return ' - ';

  return (
    <List dense>
      {filtered.map((record, index) => (
        <ListItem className="co-background" key={index} secondaryAction={`Power Source: ${record.source}`}>
          <ListItemText primary={record.operationCategory} secondary={`${record.operation} | Consumption: ${estimatedConsumption(parcel.area, record)}`}></ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

export const harvesting = (data, parcel) => {
  let filtered = data.estimated.filter(item => {
    return item.operation.toLowerCase().indexOf('harvesting') > -1 || item.operationCategory.toLowerCase().indexOf('harvesting') > -1
  });

  if (filtered.length === 0) return ' - ';

  return (
    <List dense>
      {filtered.map((record, index) => (
        <ListItem className="co-background" key={index} secondaryAction={`Power Source: ${record.source}`}>
          <ListItemText primary={record.operationCategory} secondary={`${record.operation} | Consumption: ${estimatedConsumption(parcel.area, record)}`}></ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

export const planting = (data, parcel) => {
  let filtered = data.estimated.filter(item => {
    return item.operation.toLowerCase().indexOf('sowing') > -1 || item.operationCategory.toLowerCase().indexOf('sowing') > -1
  });

  if (filtered.length === 0) return ' - ';

  return (
    <List dense>
      {filtered.map((record, index) => (
        <ListItem className="co-background" key={index} secondaryAction={`Power Source: ${record.source}`}>
          <ListItemText primary={record.operationCategory} secondary={`${record.operation} | Consumption: ${estimatedConsumption(parcel.area, record)}`}></ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

export const totalFuel = (data, parcel) => {
  console.log(data)
  if (data.isDirect) {
    let total = 0;

    data.direct.map(obj => {
      total += parseFloat(obj.amount);
    })
    return (
      <List dense>
        <ListItem className="co-background">
          <ListItemText primaryTypographyProps={{ fontWeight: 'bold' }} primary={"Total Fuel Consumption: " + `${total} L`}></ListItemText>
        </ListItem>
      </List>
    )
  } else {
    let total = 0;

    data.estimated.map(obj => {

      total += parseFloat(estimatedConsumption(parcel.area, obj))
    })

    return (
      <List dense>
        <ListItem className="co-background">
          <ListItemText primaryTypographyProps={{ fontWeight: 'bold' }} primary={"Total Fuel Consumption: " + `${total} L`}></ListItemText>
        </ListItem>
      </List>
    )
  }
}